import styled from 'styled-components'

import { error } from 'styles/colors'
import { body } from 'styles/texts'

export default styled.div`
  ${body};
  color: ${error};
`



// WEBPACK FOOTER //
// ./src/components/Error.js